module.exports = __webpack_public_path__ + "static/media/add_card.0064a39a.svg";